import { CAMERA_PRESENTER } from '@shoflo/polymer';
import { showNotification } from '@shoflo/studio-redux/actions';

import { withCurrentParams } from 'actions/utils';
import { SOURCE_CREATE } from 'store/eventConstants';
import { BROADCAST_CREATE_SOURCE } from 'actions/Types';
import {
  getSignedUrl,
  getSourceValue,
  UNASSIGNED
} from 'utils/broadcastSourceHelper';
import { setDesiredAttendeeMuteStatus } from '../attendees';
import { SOURCE_CREATE_ERROR } from '@studio/constants';

/**
 *
 * @param {*} source
 * @param {*} isInitializing boolean value to set initializing state for sources
 */
export default (source, isInitializing = false) => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const {
        meeting: { attendeeResponse }
      } = getState();
      // Don't attempt to create the action when source type is undefined
      if (!source.type) {
        return dispatch(
          showNotification(SOURCE_CREATE_ERROR, {
            type: 'warning'
          })
        );
      }

      const action = {
        type: BROADCAST_CREATE_SOURCE,
        request: async apiClient => {
          const { presenterSessionId, ...payload } = source;

          let result = await apiClient.broadcast.createSource(
            teamId,
            eventId,
            broadcastId,
            payload
          );
          result = await getSignedUrl(result, apiClient);
          socket.emit(SOURCE_CREATE, {
            broadcastId,
            notifyingDirector:
              attendeeResponse && attendeeResponse.Attendee.AttendeeId
          });
          if (result.value === UNASSIGNED && result.type === CAMERA_PRESENTER) {
            const sourceValue = getSourceValue(result);
            dispatch(setDesiredAttendeeMuteStatus(sourceValue, true));
          }
          return {
            ...result,
            isInitializing,
            presenterSessionId
          };
        }
      };
      dispatch(action);
    }
  );
};
